<template>
    <div class="main-container">
      <OpenGymLead/>
      <OpenGymAbout/>
      <OpenGymSlider/>
      <OpenGymBenefits/>
      <!-- <OpenGymPackages/> -->
      <div class="tariffs-container">
        <div class="opengym-packages-title-wrapper">
          <div class="opengym-packages-title-small">{{ $t('basicTrainingZone.packages.title') }}</div>
          <router-link to="/pricing#basic">
            <div class="opengym-packages-button">{{ $t('basicTrainingZone.packages.buttonText') }}</div>
          </router-link>
        </div>
        <div class="tariff-line tariff-line-margin">
          <TariffCard
            :name="packages.plans[0].name ?? ''"
            :description="packages.plans[0].description ?? ''"
            :price="packages.plans[0].price ?? ''"
            :period="packages.plans[0].period ?? ''"
            direction="horizontal"
            :color="packages.plans[0].color ?? ''"
            page="contract"
          />
          <TariffCard
            :name="packages.plans[1].name ?? ''"
            :description="packages.plans[1].description ?? ''"
            :price="packages.plans[1].price ?? ''"
            :period="packages.plans[1].period ?? ''"
            direction="horizontal"
            :color="packages.plans[1].color ?? ''"
            page="contract"
          />
        </div>
        <div class="tariff-line tariff-between-margin">
          <TariffCard
            :name="packages.plans[2].name ?? ''"
            :description="packages.plans[2].description ?? ''"
            :price="packages.plans[2].price ?? ''"
            :period="packages.plans[2].period ?? ''"
            direction="horizontal"
            :color="packages.plans[2].color ?? ''"
            page="contract"
          />
          <TariffCard
            :name="packages.plans[3].name ?? ''"
            :description="packages.plans[3].description ?? ''"
            :price="packages.plans[3].price ?? ''"
            :period="packages.plans[3].period ?? ''"
            direction="horizontal"
            :color="packages.plans[3].color ?? ''"
            page="contract"
          />
        </div>
        <div class="tariff-line tariff-between-margin">
          <TariffCard
            :name="packages.plans[4].name ?? ''"
            :description="packages.plans[4].description ?? ''"
            :price="packages.plans[4].price ?? ''"
            :period="packages.plans[4].period ?? ''"
            direction="horizontal"
            :color="packages.plans[4].color ?? ''"
            page="contract"
          />
          <TariffCard
            :name="packages.plans[5].name ?? ''"
            :description="packages.plans[5].description ?? ''"
            :price="packages.plans[5].price ?? ''"
            :period="packages.plans[5].period ?? ''"
            direction="horizontal"
            :color="packages.plans[5].color ?? ''"
            page="contract"
          />
        </div>
      </div>
      <OpenGymFaq/>
    </div>
</template>

<script>
// import SiteHeader from "@/components/common/SiteHeader";
import OpenGymLead from "@/components/opengym/OpenGymLead";
import OpenGymAbout from "@/components/opengym/OpenGymAbout";
import OpenGymSlider from "@/components/opengym/OpenGymSlider";
import OpenGymBenefits from "@/components/opengym/OpenGymBenefits";
// import MainContacts from "@/components/common/MainContacts";
// import MainForm from "@/components/common/MainForm";
// import OpenGymPackages from "@/components/opengym/OpenGymPackages";
import OpenGymFaq from "@/components/opengym/OpenGymFaq";
import TariffCard from "@/components/tariffs/TariffCard";
import packages from "@/resources/packages.json";
// import MainFooter from "@/components/common/MainFooter";

export default {
  name: "OpenGymView",
  components: {
    OpenGymFaq,
    // OpenGymPackages,
    OpenGymBenefits,
    OpenGymSlider,
    OpenGymAbout,
    OpenGymLead,
    TariffCard,
    // SiteHeader,
    // MainFooter,
    // MainForm,
    // MainContacts,
  },
  data() {
    return {
      packages,
    };
  },
  beforeMount() {
    switch (this.$i18n.locale) {
      case 'en':
        this.packages = this.packages.plans.en
        break;
      case 'et':
        this.packages = this.packages.plans.et
        break;
      case 'ru':
        this.packages = this.packages.plans.ru
        break;
      default:
        this.packages = this.packages.plans.en
        break;
    }
  },
}
</script>

<style scoped>

.opengym-packages-title-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.opengym-packages-title-small {
  max-width: 600px;
  font-size: 28px;
  font-weight: bold;
  white-space: pre-line;
}

@media screen and (min-width: 768px) {
  .opengym-packages-title-small {
    font-size: 32px;
  }
}

@media screen and (min-width: 1024px) {
  .opengym-packages-title-small {
    font-size: 40px;
  }
}

.opengym-packages-button {
  font-size: 20px;
  padding: 6px 32px;
  border: 2px solid #000000;
  background-color: #000000;
  color: white;
  border-radius: 40px;
  cursor: pointer;
  white-space: nowrap;
}

@media screen and (min-width: 768px) {
  .opengym-packages-button {
    font-size: 24px;
  }
}

.opengym-packages-button:hover {
  background-color: white;
  color: #000000;
  transition: all 0.3s;
}

.tariffs-container {
  max-width: 1440px;
  margin: 40px auto 40px;
  padding: 0 16px;
}

@media screen and (min-width: 768px) {
  .tariffs-container {
    margin: 60px auto 60px;
    padding: 0 24px;
  }
}

@media screen and (min-width: 1024px) {
  .tariffs-container {
    margin: 80px auto 80px;
  }
}

.tariff-line {
  display: flex;
  gap: 24px;
  flex-direction: column;
  align-items: center;
}

@media screen and (min-width: 1140px) {
  .tariff-line {
    flex-direction: row;
    align-items: stretch;
  }
}

.tariff-line-margin {
  margin-top: 28px;
}

@media screen and (min-width: 768px) {
  .tariff-line-margin {
    margin-top: 42px;
  }
}

@media screen and (min-width: 1024px) {
  .tariff-line-margin {
    margin-top: 56px;
  }
}

.tariff-between-margin {
  margin-top: 16px;
}

@media screen and (min-width: 768px) {
  .tariff-between-margin {
    margin-top: 24px;
  }
}

</style>
